/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserStatusPing } from './UserStatusPing';
import {
    UserStatusPingFromJSON,
    UserStatusPingFromJSONTyped,
    UserStatusPingToJSON,
    UserStatusPingToJSONTyped,
} from './UserStatusPing';

/**
 * 
 * @export
 * @interface GroupUserStatusesOnAzure
 */
export interface GroupUserStatusesOnAzure {
    /**
     * 
     * @type {string}
     * @memberof GroupUserStatusesOnAzure
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof GroupUserStatusesOnAzure
     */
    group_name: string;
    /**
     * 
     * @type {{ [key: string]: UserStatusPing; }}
     * @memberof GroupUserStatusesOnAzure
     */
    user_statuses: { [key: string]: UserStatusPing; };
    /**
     * 
     * @type {string}
     * @memberof GroupUserStatusesOnAzure
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GroupUserStatusesOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof GroupUserStatusesOnAzure
     */
    _ts: number;
}

/**
 * Check if a given object implements the GroupUserStatusesOnAzure interface.
 */
export function instanceOfGroupUserStatusesOnAzure(value: object): value is GroupUserStatusesOnAzure {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('group_name' in value) || value['group_name'] === undefined) return false;
    if (!('user_statuses' in value) || value['user_statuses'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    return true;
}

export function GroupUserStatusesOnAzureFromJSON(json: any): GroupUserStatusesOnAzure {
    return GroupUserStatusesOnAzureFromJSONTyped(json, false);
}

export function GroupUserStatusesOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupUserStatusesOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'group_name': json['group_name'],
        'user_statuses': (mapValues(json['user_statuses'], UserStatusPingFromJSON)),
        'id': json['id'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
    };
}

export function GroupUserStatusesOnAzureToJSON(json: any): GroupUserStatusesOnAzure {
    return GroupUserStatusesOnAzureToJSONTyped(json, false);
}

export function GroupUserStatusesOnAzureToJSONTyped(value?: GroupUserStatusesOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'group_name': value['group_name'],
        'user_statuses': (mapValues(value['user_statuses'], UserStatusPingToJSON)),
        'id': value['id'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
    };
}

